<organization-top-navbar></organization-top-navbar>

<div class="block; relative isolate px-6 pt-10 lg:px-8">
  <div class="mx-auto max-w-5xl px-4 py-6">
    <div class="text-[#1B3777] text-center text-3xl lg:text-4xl  DisplayHeading self-stretch font-bold">{{
      'DRIVE_IN_BOOKING.COMPLETE_BOOKING' | transloco }}</div>
  </div>
</div>

<div class="container margin-auto">

  @if (showbookingDetailsForm) {
  <section class="img-container img-fluid pt-4">
    <div class="pt-4 pb-2">
      <div class=" text-[#1B3777] text-xl md:text-2xl font-bold md:block w-97 leading-normal tracking-wide">{{
        'DRIVE_IN_BOOKING.PARKING_DETAILS' | transloco }}</div>
    </div>
  </section>
  }

  @if (showbookingDetailsForm) {
  <div class="margin-top-bottom-20">
    <form [formGroup]="parkingDatesForm">
      <!-- Date Display -->
      <div class="rounded-2xl flex-col justify-start items-start flex form-section-padding-16">
        <div class="flex flex-col gap-4 w-full">
          <div>
            <div class="text-sm text-gray-600 mb-1">{{ 'CHECKIN_CHECKOUT.PARKING_FROM' | transloco }}
            </div>
            <div class="text-lg font-medium">{{ parkingDatesForm.controls['startDate'].value |
              date:'yyyy/MM/dd' }} {{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco)}} {{
              parkingDatesForm.controls['startTime'].value }}</div>
          </div>
          <div>
            <div class="text-sm text-gray-600 mb-1">{{ 'CHECKIN_CHECKOUT.PARKING_TO' | transloco }}</div>
            <div class="text-lg font-medium">{{ parkingDatesForm.controls['endDate'].value |
              date:'yyyy/MM/dd' }} {{ " " + ("PARKIFLY.CLOCK_SHORT" | transloco)}} {{
              parkingDatesForm.controls['endTime'].value }}</div>
          </div>
        </div>
      </div>
      <!-- Interactive form for Quality orders -->
      <!-- <div *ngIf="driveInBookingForm.orgId === '942ce067-7848-4441-b746-8f6eed7395bb'"
        class="rounded-2xl flex-col justify-start items-start flex"
        class="form-section-padding">
        <div class="mx-auto max-w-4xl w-full">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div
              class="low-opacity calender-border w-full p-4 bg-gray-100 rounded-4xl flex items-center justify-between">
              <div>
                <label class="block text-sm text-gray-600">{{ 'DRIVE_IN_BOOKING.START_DATE' | transloco
                }}</label>
                <p class="text-gray-800">{{ parkingDatesForm.controls['startDate'].value |
                date:'yyyy/MM/dd' }}</p>
              </div>
              <mat-icon class="text-gray-500 ml-5">event</mat-icon>
            </div>
            <div
              class="low-opacity calender-border w-full p-4 bg-gray-100 rounded-4xl flex items-center justify-between">
              <div>
                <label class="block text-sm text-gray-600">{{ 'DRIVE_IN_BOOKING.START_TIME' | transloco
                }}</label>
                <p class="text-gray-800">{{ parkingDatesForm.controls['startTime'].value }}</p>
              </div>
              <mat-icon class="text-gray-500 ml-5">alarm</mat-icon>
            </div>
            <div class="w-full">
              <mat-form-field appearance="fill" class="calender-border cursor-pointer w-full"
                (click)="endPicker.open()">
                <mat-label>{{ 'DRIVE_IN_BOOKING.END_DATE' | transloco }}</mat-label>
                <input matInput [min]="minEndDate" [matDatepicker]="endPicker"
                  [formControl]="parkingDatesForm.controls['endDate']">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                <mat-hint>{{ 'DRIVE_IN_BOOKING.END_DATE_HINT' | transloco }}</mat-hint>
              </mat-form-field>
              <div class="text-sm text-gray-500 mt-1 px-3">{{ 'DRIVE_IN_BOOKING.END_DATE_HINT' | transloco
              }}</div>
            </div>
            <div class="w-full">
              <mat-form-field appearance="fill" class="calender-border w-full">
                <mat-label>{{ 'DRIVE_IN_BOOKING.END_TIME' | transloco }}</mat-label>
                <input matInput type="time" step="60"
                  [formControl]="parkingDatesForm.controls['endTime']" class="padding-0">
                <mat-icon matSuffix>alarm</mat-icon>
                <mat-hint>{{ 'DRIVE_IN_BOOKING.END_TIME_HINT' | transloco }}</mat-hint>
              </mat-form-field>
              <div class="text-sm text-gray-500 mt-1 px-3">{{ 'DRIVE_IN_BOOKING.END_TIME_HINT' | transloco
              }}</div>
            </div>
          </div>
        </div>
      </div> -->
    </form>
  </div>
  }

  @if (showDetailsPage && !showPaymentOption) {
  <div #detailsSection class="margin-top-bottom-20">
    <!-- Price Display -->
    @if (parkingDatesForm.controls.endDate.value !== null && parkingDatesForm.controls.endTime.value !== null) {
      <div class="rounded-2xl flex-col justify-start items-start flex success-box-padding">
      <div class="flex justify-between items-center w-full">
        <div class="flex flex-col">
          <h3 class="heading-green-600">{{ 'DRIVE_IN_BOOKING.PARKING_PRICE' |
            transloco }}</h3>
          <div class="flex items-center gap-3 mt-2">
            <span class="price-text-green">{{driveInBookingForm?.price}}
              SEK</span>
          </div>
        </div>
        <div class="hidden sm:flex items-center text-green">
          <mat-icon class="icon-32">local_parking</mat-icon>
        </div>
      </div>
    </div>
    }
    @if (showbookingDetailsForm) {
    <section class="img-container img-fluid">
      <div class="pt-4 pb-2">
        <div class=" text-[#1B3777] text-xl md:text-2xl font-bold md:block w-97 leading-normal tracking-wide">{{
          'DRIVE_IN_BOOKING.ADD_BOOKING_DETAILS' | transloco }}</div>
      </div>
    </section>
    }
    <form [formGroup]="bookingDetailsForm">
      <div class="rounded-2xl flex-col justify-start items-start flex form-section-border">
        <div class="self-stretch justify-start items-start flex flex-col lg:flex-row">
          <div class="grow shrink basis-0 h-20 justify-start items-start flex w-full">
            <div class="grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex border-bottom-gray lg:border-r lg:border-r-[#aaaaaa]">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'DRIVE_IN_BOOKING.FIRST_NAME' | transloco }}</mat-label>
                <input matInput [formControl]="bookingDetailsForm.controls['firstName']">
              </mat-form-field>
            </div>
          </div>
          <div class="grow shrink basis-0 h-20 justify-start items-start flex w-full">
            <div class="grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex border-bottom-gray">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'DRIVE_IN_BOOKING.LAST_NAME' | transloco }}</mat-label>
                <input matInput [formControl]="bookingDetailsForm.controls['lastName']">
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="self-stretch justify-start items-start flex flex-col lg:flex-row">
          <div class="grow shrink basis-0 h-20 justify-start items-start flex w-full">
            <div
              class="grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex lg:border-r lg:border-r-[#aaaaaa] border-b lg:border-b-0 border-b-[#aaaaaa]">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'DRIVE_IN_BOOKING.EMAIL' | transloco }}</mat-label>
                <input matInput [formControl]="bookingDetailsForm.controls['email']">
              </mat-form-field>
            </div>
          </div>
          <div class="grow shrink basis-0 h-20 justify-start items-start flex w-full">
            <div class="grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'DRIVE_IN_BOOKING.PHONE' | transloco }}</mat-label>
                <input matInput [formControl]="bookingDetailsForm.controls['phone']">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="Frame840 self-stretch h-32 flex-col justify-start items-start gap-4 flex">
        <div class="Frame806 self-stretch h-7 flex-col justify-start items-start gap-4 flex">
          <div class="Villkor text-black text-lg font-bold leading-loose">{{'PARKIFLY.DETAILS.TERMS' |
            transloco}}</div>
        </div>
        <div class="Bagage self-stretch p-4 bg-neutral-50 rounded-xl justify-start items-center gap-4 inline-flex h-[82px] border-gray" (click)="triggerConsent()">
          <div class="FormFieldsCheckboxInput w-4 h-4 relative">
            <pf-checkbox [inputFormControl]="this.bookingDetailsForm.controls.consent"></pf-checkbox>
          </div>
          <div class="Frame539 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
            <div class="Checkbox justify-start items-center gap-2 inline-flex">
              <div class="Title text-blue-900 text-sm font-medium leading-none">{{'PARKIFLY.FORM.TERMS' |
                transloco}}
              </div>
            </div>
            <div class="Checkbox justify-start items-center gap-2 inline-flex">
              <div
                class="Title text-blue-600 text-sm font-medium leading-normal tracking-tight cursor-pointer hover:underline"
                (click)="$event.stopPropagation();openTermsModal(); false">{{'PARKIFLY.FORM.READ_MORE' |
                transloco}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-space-between-mt-2rem">
        <button mat-raised-button color="warn" type="button" (click)="resetBookingDetailsForm()">{{ 'FORM.CLEAR'
          |
          transloco | uppercase}}</button>
        <button mat-raised-button type="button" [ngStyle]="{
                      'background-color': (isLoading || !bookingDetailsForm.valid || !parkingDatesForm.valid) ? '#grey' : '#4CAF50',
                      'color': (isLoading || !bookingDetailsForm.valid || !parkingDatesForm.valid) ? 'black' : 'white'
                    }" (click)="createBooking()"
          [disabled]="isLoading || !bookingDetailsForm.valid || !parkingDatesForm.valid">
          @if (isLoading) {
          <mat-icon>
            <mat-spinner color="accent" diameter="20"></mat-spinner>
          </mat-icon>
          }
          {{ 'DRIVE_IN_BOOKING.TO_PAYMENT' | transloco }}
        </button>
      </div>
    </form>
  </div>
  }

  @if (!showDetailsPage && showPaymentOption) {
  <div class="margin-top-bottom-20">
    <div class="UppgifterWrapper self-stretch flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="flex w-full justify-between">
        <div class="DinaUppgifter text-black text-lg font-bold  leading-loose">
          {{'PARKIFLY.PAYMENT.PAYMENT_METHOD' | transloco}}
        </div>
      </div>
      <label
        class="PaymentInput self-stretch  p-8 bg-white rounded-xl shadow flex-col justify-start items-start gap-4 flex">
        <div class="PaymentInput self-stretch w-full block">
          @if (!paymentLoadError) {
          <div class="mt-3 w-full" id="swedbank-pay-seamless-view-page"></div>
          }
          @if (paymentLoadError) {
          <div class="mt-3 w-full text-center p-4">
            <p class="mb-4 text-gray-600">{{ 'DRIVE_IN_BOOKING.PAYMENT_LOADING_ERROR' | transloco }}</p>
            <button mat-raised-button color="primary" (click)="getOrder()">
              {{ 'DRIVE_IN_BOOKING.RETRY' | transloco }}
            </button>
          </div>
          }
        </div>
      </label>
    </div>
  </div>
  }

</div>